var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 47 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.002 6.817V4.545c0-2.503 2.09-4.545 4.645-4.545h9.377c2.571 0 4.645 2.03 4.645 4.543v2.274h11.726a2.273 2.273 0 1 1 0 4.545H2.275a2.273 2.273 0 0 1 0-4.545h11.727zm4.665 0h9.335v-2.27H18.67c-.002 0-.004.758-.002 2.273v-.003zM4.67 13.638h4.666V43.2c0 1.243 1.045 2.255 2.347 2.255H34.99c1.298 0 2.346-1.017 2.346-2.255V13.637h4.667V43.2c0 3.757-3.145 6.8-7.013 6.8H11.682C7.81 50 4.67 46.96 4.67 43.2V13.637v.001zm11.666 9.084c0-1.25 1.035-2.267 2.334-2.267 1.288 0 2.333 1.032 2.333 2.267v13.65c0 1.251-1.035 2.266-2.333 2.266-1.289 0-2.334-1.03-2.334-2.266v-13.65zm9.334 0c0-1.25 1.035-2.267 2.333-2.267 1.288 0 2.333 1.032 2.333 2.267v13.65c0 1.251-1.035 2.266-2.333 2.266-1.288 0-2.333-1.03-2.333-2.266v-13.65z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon-trash.03f3599f09ee0233f81ffde91189c0ad.svg";
export { ForwardRef as ReactComponent };